import {emptyValue} from "./global";
import translateSwitchStatus from "./translateSwitchStatus";

function getDisplaySwitchingStatus(switching_status) {
    let translatedStatus = translateSwitchStatus(switching_status);
    if (translatedStatus === null) return emptyValue; //if no translation found return default val
    return translatedStatus;
}

export default getDisplaySwitchingStatus;